import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { resolveExternalNetworkGraphVantagePoint } from '@terra/ui-graphs';
import { useExternalNetworkSurfaceDetail } from './useSurfaceSettings';
import { useInternalAccessNetworks } from './useInternalAccessNetworks';

export const useExternalNetworkGraphVantagePoint = (
  surfaceId: string | null,
) => {
  const t = useTranslations('externalNetwork');
  const { data: surface } = useExternalNetworkSurfaceDetail(surfaceId);
  const egressStrategy = surface?.egressStrategy;
  const { networks } = useInternalAccessNetworks({
    enabled: egressStrategy === 'CONNECTOR',
  });
  const networkName = networks.find(
    (network) => network.id === surface?.internalAccessNetworkId,
  )?.displayName;
  const connectorLabel = networkName ?? t('graph.connectorRoot');

  return useMemo(
    () =>
      resolveExternalNetworkGraphVantagePoint({
        egressStrategy,
        connectorLabel,
      }),
    [egressStrategy, connectorLabel],
  );
};
